<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Import Employee Attendance</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id"
                        label="Academic Year" dense outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" v-if="ay != null">

                <v-col cols="12" sm="2" md="2" class="pt-5 mt-2">
                    <v-checkbox v-model="in_time" label="Import In Time"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pt-5 mt-2">
                    <v-checkbox v-model="out_time" label="Import Out Time"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of employee data" prepend-icon="mdi-file" label="Employee Data"
                        rounded dense flat outlined show-size v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/Import_employee_attendance.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <span> <b>Note:-&nbsp;&nbsp;</b>If attendance of faculty is freezed for the date mentioned in file, it
                    won't update the timings. </span>
            </v-row>
            <v-row justify="center" align="center">
                <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
            </v-row>

            <v-col cols="12" sm="12" md="12">
                <template v-if="load == true">
                    <v-data-table v-if="failedlist != ''" :headers="headers1" :items="failedlist" sort-by
                        class="elevation-1 mytable" dense :search="search" :loading="output_load">
                        <template v-slot:top>
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Failed Data</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <br />
                        </template>
                    </v-data-table>
                    <v-data-table v-if="statuslist != ''" :headers="headers" :items="statuslist" sort-by
                        class="elevation-1 mytable" dense :search="search" :loading="output_load">
                        <template v-slot:top>
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Success Data</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <br />
                        </template>
                    </v-data-table>
                </template>
            </v-col>
        </v-card>
    </div>
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      /*
    Defines the data used by the component
  */
      data() {
          return {
              file: null,
              statuslist: "",
              failedlist: "",
              load: false,
              loading3: false,
              search: "",
              snackbar_msg: "",
              color: "",
            //   extraBreadcrumbItems: [


            //   ],
            //   breadcrumbClass: "breadcrumb-style1",
              snackbar: false,
              in_time:true,
              out_time:true,
              headers: [
                  { text: "Sr.NO", value: "serial_number" },
                  { text: "Login Id", value: "employeecode" },
                  { text: "Reason", value: "reason" },
                  { text: "In Time", value: "intime" },
                  { text: "Out Time", value: "outtime" },
                  { text: "Day", value: "day" },
                  { text: "Month", value: "month" },
                  { text: "Year", value: "year" },
              ],
              headers1: [
                  { text: "Sr.NO", value: "serial_number" },
                  { text: "Login Id", value: "employeecode" },
                  { text: "Reason", value: "reason" },
                  { text: "In Time", value: "intime" },
                  { text: "Out Time", value: "outtime" },
                  { text: "Day", value: "day" },
                  { text: "Month", value: "month" },
                  { text: "Year", value: "year" },
              ],

              output_load: false,
              ay_list: [],
              ay: null,
          };
      },

      methods: {
          submitFile() {
              if (this.file == null) {
                  alert("Please select the file!");
              } else {
                  this.output_load = true;
                  let formData = new FormData();
                  //console.log(this.file.size);
                  formData.append("file", this.file);
                  formData.append("ay", this.ay);
                  formData.append("in_time", this.in_time);
                  formData.append("out_time", this.out_time);

                  //console.log(formData)
                  axios
                      .post("EmployeeBiometric/importbulkemployeeattendance", formData, {
                          headers: {
                              "Content-Type": "multipart/form-data",
                          },
                      })
                      .then((res) => {
                          if (res.data.msg == "200") {
                              console.log(res.data.statuslist[0].failedlist);
                              this.statuslist = res.data.statuslist[0].statuslist;
                              this.failedlist = res.data.statuslist[0].failedlist;
                              this.load = true;
                              this.showSnackbar("#4caf50", "Imported Successfully !!");
                          }
                      })
                      .catch((error) => {
                          this.onerror(error);
                      })
                      .finally(() => {
                          this.output_load = false;
                      });
              }

              //     }
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          onerror(error) {
              let msg = "";
              if (error.response) {
                  msg = "Something went wrong.";
              } else if (error.request) {
                  msg = "Please try again.";
              } else {
                  msg = "Un-expected error.";
              }
              this.showSnackbar("error", msg);
          },
          onLoad() {
              this.overlay = true;
              axios
                  .post("EmployeeBiometric/createEmployeeAttendance")
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          (this.ay_list = res.data.aylist), (this.ay = res.data.curreny_ay);
                      } else {
                          this.showSnackbar("#b71c1c", res.data.status_reason);
                      }
                      this.overlay = false;
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong!!!");
                      this.overlay = false;
                  })
                  .finally(() => {
                      this.overlay = false;
                  });
          },

          /*
      Handles a change on the file upload
    */
      },
      mounted() {
          this.onLoad();
      },
  };
</script>
<style scoped>
  .downbtn {
      float: right;
  }

  /* new css */
  table,
  th {
      padding: 10px;
      border: 1px solid black;
      border-collapse: collapse;
      background: #0f2027; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  .mandatory {
      color: red;
  }
</style>
